import { listVndlyCandidateIssues } from 'api/admin/vndly/listVndlyCandidateIssues'
import { listVndlyPositionIssues } from 'api/admin/vndly/listVndlyPositionIssues'
import { listVndlyWorkOrderIssues } from 'api/admin/vndly/listVndlyWorkOrderIssues'

const vndlyKey = ['vndly'] as const

export const vndlyKeys = {
  all: vndlyKey,
  instances: () => [...vndlyKey, 'instances'] as const,
  positionIssues: () => [...vndlyKey, 'positionIssues'] as const,
  positionIssuesList: (
    params?: Parameters<typeof listVndlyPositionIssues>[0]
  ) =>
    [
      ...vndlyKeys.positionIssues(),
      params?.page,
      params?.pageSize,
      params?.instanceIds,
      params?.companyIds,
    ] as const,
  candidateIssues: () => [...vndlyKey, 'candidateIssues'] as const,
  candidateIssuesList: (
    params?: Parameters<typeof listVndlyCandidateIssues>[0]
  ) =>
    [
      ...vndlyKeys.candidateIssues(),
      params?.page,
      params?.pageSize,
      params?.daysAgo,
      params?.instanceIds,
      params?.companyIds,
    ] as const,
  workOrderIssues: () => [...vndlyKey, 'workOrderIssues'] as const,
  workOrderIssuesList: (
    params?: Parameters<typeof listVndlyWorkOrderIssues>[0]
  ) =>
    [
      ...vndlyKeys.workOrderIssues(),
      params?.page,
      params?.pageSize,
      params?.daysAgo,
      params?.instanceIds,
      params?.companyIds,
    ] as const,
}
